import placeholderImg from '../images/placeholder.png'; // at top of file
import { Helmet } from "react-helmet-async";

import React, { useState, useEffect, useMemo, useRef } from 'react';
import axios from 'axios';
import './HomePage.css';
import { Link, useNavigate } from 'react-router-dom';
import PartnersSlideshow from './PartnersSlideshow';
import Footer from './Footer';
import Header from './Header';
import PartnersSection from "./PartnersSection";


import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { FaCheckSquare, FaWpforms } from 'react-icons/fa';
import { HiOutlineDocumentSearch } from 'react-icons/hi';
import { BsChatDots } from 'react-icons/bs';


const JobCard = ({ job, jobDescriptionStyle }) => (
  <li>
    <Link
      to={`/jobs/${job.id}`}
      className="job-card-link"
      style={{ textDecoration: 'none', color: 'inherit', height: '100%' }}
    >
      {job.photo && (
        // <img
        //   className="job-post-photo-homePage"
        //   src={job.photo}
        //   alt={job.job_name}
        // />
        <img
          className="job-post-photo-homePage"
          src={job.photo || placeholderImg}
          alt={job.job_name || "Job image"}
          onError={(e) => { e.target.src = placeholderImg; }}
        />

      )}

      {/* location + type pill */}
      <div className="job-card-location">
        <span className="job-card-location-icon">📍</span>
        <span>{job.job_location}</span>
        <span
          className={`job-card-type-pill ${
            job.job_type === 'Stalni'
              ? 'job-card-type-stalni'
              : 'job-card-type-sezonski'
          }`}
        >
          {job.job_type}
        </span>
      </div>

      <h3 className="job-post-title-homePage">{job.job_name}</h3>

      <div style={jobDescriptionStyle} className="job-post-description-homePage">
        {job.shortDescription}
      </div>

      <div className="homePage-job-card-details">
        <div className="homePage-detail-item">
          <div className="homePage-detail-label"><b>Objavljen</b></div>
          <div className="homePage-detail-value">
            <span className="icon">📅</span>
            {job.postedAt ? new Date(job.postedAt).toLocaleDateString() : '-'}
          </div>
        </div>
        <div className="homePage-detail-item">
          <div className="homePage-detail-label"><b>Početak rada</b></div>
          <div className="homePage-detail-value">
            <span className="icon">🗓</span>
            {job.startDate ? new Date(job.startDate).toLocaleDateString() : '-'}
          </div>
        </div>
        <div className="homePage-detail-item">
          <div className="homePage-detail-label"><b>Plata</b></div>
          <div className="homePage-detail-value">
            <span className="icon">💶</span>€{job.salary}/mj
          </div>
        </div>
        <div className="homePage-detail-item">
          <div className="homePage-detail-label"><b>Slobodan dan</b></div>
              <div className="homePage-detail-value">
                  <span className="icon">🆓</span>
                      {job.freeDay ? 'Da' : 'Ne'}
                </div>
          </div>
      </div>
    </Link>
  </li>
);

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

function HomePage() {

  const [jobs, setJobs] = useState([]);
  const [animateKey, setAnimateKey] = useState(0);
  const navigate = useNavigate();

  // Search inputs (removed allSearch)
  const [jobTypeSearch, setJobTypeSearch] = useState('');
  const [locationSearch, setLocationSearch] = useState('');
  const [positionSearch, setPositionSearch] = useState('');

  // Suggestions
  const [locationSuggestions, setLocationSuggestions] = useState([]);
  const [positionSuggestions, setPositionSuggestions] = useState([]);
  const [showLocationSuggestions, setShowLocationSuggestions] = useState(false);
  const [showPositionSuggestions, setShowPositionSuggestions] = useState(false);
  const [showJobTypeSuggestions, setShowJobTypeSuggestions] = useState(false);


  // === Allowed-value helpers (only allow dropdown items) ===
const norm = (s) => s.trim().toLowerCase();

// Build canonical maps from fetched suggestions (case-insensitive lookups)
const locationMap = useMemo(() => {
  const m = new Map();
  ['CRO', 'MNE', ...locationSuggestions.map(i => i.job_location)]
    .forEach(v => m.set(norm(v), v));
  return m;
}, [locationSuggestions]);

const positionMap = useMemo(() => {
  const m = new Map();
  positionSuggestions.map(i => i.job_name)
    .forEach(v => m.set(norm(v), v));
  return m;
}, [positionSuggestions]);

// Token utilities
const tokensFrom = (input) =>
  input.split(',').map(t => t.trim()).filter(Boolean);

const filterToAllowed = (tokens, canonMap) => {
  const valid = [];
  const invalid = [];
  tokens.forEach(t => {
    const hit = canonMap.get(norm(t));
    if (hit) {
      if (!valid.includes(hit)) valid.push(hit); // de-dup
    } else {
      invalid.push(t);
    }
  });
  return { valid, invalid };
};

// Commiters for onBlur (clean free text to only allowed values)
const commitLocations = () => {
  const { valid } = filterToAllowed(tokensFrom(locationSearch), locationMap);
  setLocationSearch(valid.join(', ')); // <-- no trailing comma on blur
};

const commitPositions = () => {
  const { valid } = filterToAllowed(tokensFrom(positionSearch), positionMap);
  setPositionSearch(valid.join(', ')); // <-- no trailing comma on blur
};


// Block Enter if last token isn't valid yet (optional but nice)
const guardEnter = (e, currentInput, canonMap) => {
  if (e.key === 'Enter') {
    const toks = tokensFrom(currentInput);
    const last = toks[toks.length - 1] || '';
    if (last && !canonMap.get(norm(last))) {
      e.preventDefault(); // don't submit until a valid suggestion is chosen
    }
  }
};


  // Refs for outside-click
  const locationDropdownRef = useRef(null);
  const positionDropdownRef = useRef(null);
  const jobTypeDropdownRef = useRef(null);

  const jobTypeOptions = ['Stalni', 'Sezonski'];

  const getLastToken = (input) => {
    const tokens = input.split(',');
    return tokens[tokens.length - 1].trim();
  };

  // const handleLocationInputChange = (e) => {
  //   setLocationSearch(e.target.value);
  // };

  const handleLocationInputChange = (e) => {
  const validated = validateAlphaInput(e.target.value);
  setLocationSearch(validated);
};

const handlePositionInputChange = (e) => {
  const validated = validateAlphaInput(e.target.value);
  setPositionSearch(validated);
};

const handleJobTypeInputChange = (e) => {
  const validated = validateAlphaInput(e.target.value);
  setJobTypeSearch(validated);
};

// Show a trailing ", " only while the input is focused/editing
const addTrailingWhileEditing = (val) =>
  val && !/,\s*$/.test(val) ? val + ', ' : val;


const locationInputRef = useRef(null);
const positionInputRef = useRef(null);



  const validateAlphaInput = (value) => {
  return value
    .replace(/[^a-zA-Z0-9ćčžšđĆČŽŠĐ,\s\-\/']/g, '');
};

        const handleLocationSuggestionClick = (suggestion) => {
          const prev = locationSearch;
          const endsWithComma = prev.trimEnd().endsWith(',');
          let tokens = prev.split(',').map(t => t.trim()).filter(Boolean);

          if (tokens.length && !endsWithComma) {
            // replace the in-progress last token
            tokens[tokens.length - 1] = suggestion;
          } else if (tokens.includes(suggestion)) {
            // toggle off if already present
            tokens = tokens.filter(t => t !== suggestion);
          } else {
            tokens.push(suggestion);
          }

          // Always: clean value (no trailing comma), close, blur
          setLocationSearch(tokens.join(', '));
          setShowLocationSuggestions(false);
          requestAnimationFrame(() => locationInputRef.current?.blur());
        };

      const handlePositionSuggestionClick = (suggestion) => {
        const prev = positionSearch;
        const endsWithComma = prev.trimEnd().endsWith(',');
        let tokens = prev.split(',').map(t => t.trim()).filter(Boolean);

        if (tokens.length && !endsWithComma) {
          tokens[tokens.length - 1] = suggestion;
        } else if (tokens.includes(suggestion)) {
          tokens = tokens.filter(t => t !== suggestion);
        } else {
          tokens.push(suggestion);
        }

        setPositionSearch(tokens.join(', '));
        setShowPositionSuggestions(false);
        requestAnimationFrame(() => positionInputRef.current?.blur());
      };

  const handleJobTypeSuggestionClick = (suggestion) => {
    const trimmedSearch = jobTypeSearch.trimEnd();
    const endsWithComma = trimmedSearch.endsWith(',');

    let tokens = jobTypeSearch
      .split(',')
      .map((token) => token.trim())
      .filter((token) => token !== '');

    if (tokens.length > 0 && tokens[tokens.length - 1] === suggestion && !endsWithComma) {
      setJobTypeSearch(tokens.join(', ') + ', ');
      return;
    }

    if (tokens.includes(suggestion)) {
      tokens = tokens.filter((token) => token !== suggestion);
    } else {
      if (!endsWithComma && tokens.length > 0) {
        tokens[tokens.length - 1] = suggestion;
      } else {
        tokens.push(suggestion);
      }
    }
    setJobTypeSearch(tokens.length ? tokens.join(', ') + ', ' : '');
  };

  // Close dropdowns on outside click (after the button click/submit fires)
  useEffect(() => {
    const inside = (ref, target) => ref?.current && ref.current.contains(target);

    const onDocClick = (e) => {
      if (
        inside(locationDropdownRef, e.target) ||
        inside(positionDropdownRef, e.target) ||
        inside(jobTypeDropdownRef, e.target)
      ) return;

      requestAnimationFrame(() => {
        setShowLocationSuggestions(false);
        setShowPositionSuggestions(false);
        setShowJobTypeSuggestions(false);
      });
    };

    document.addEventListener('click', onDocClick);
    return () => document.removeEventListener('click', onDocClick);
  }, []);

const handleNewSearch = (e) => {
  if (e) e.preventDefault();

  // Filter to allowed tokens only (case-insensitive)
  const locTok = tokensFrom(locationSearch);
  const posTok = tokensFrom(positionSearch);

  const { valid: locValid, invalid: locInvalid } = filterToAllowed(locTok, locationMap);
  const { valid: posValid, invalid: posInvalid } = filterToAllowed(posTok, positionMap);

  // Show cleaned values back to the user
 setLocationSearch(locValid.join(', '));
  setPositionSearch(posValid.join(', '));


  // Optional feedback if anything got dropped
  if ((locInvalid.length || posInvalid.length) && typeof toast === 'function') {
    toast.info('Neke stavke su uklonjene jer nijesu na listi.');
  }

  const params = {};
  if (jobTypeSearch.trim()) params.jobType = jobTypeSearch.trim();
  if (locValid.length) params.location = locValid.join(', ');
  if (posValid.length) params.position = posValid.join(', ');

  const queryString = new URLSearchParams(params).toString();
  navigate(`/jobs-page?${queryString}`);
};


  useEffect(() => {
    const fetchLocations = async () => {
      try {
        // const response = await axios.get('http://localhost:5000/job-locations');
        const response = await axios.get(`${API_BASE_URL}/job-locations`);
        setLocationSuggestions(response.data);
      } catch (err) {
        console.error('Error fetching locations:', err.message);
        toast.error('Greška pri učitavanju lokacija. Pokušajte ponovo kasnije.');
        setLocationSuggestions([]); // fallback
      }

    };

    const fetchPositions = async () => {
      try {
        // const response = await axios.get('http://localhost:5000/job-names');
        const response = await axios.get(`${API_BASE_URL}/job-names`);
        setPositionSuggestions(response.data);
      } catch (err) {
        console.error('Error fetching positions:', err.message);
        toast.error('Greška pri učitavanju pozicija. Pokušajte ponovo kasnije.');
        setPositionSuggestions([]);
      }

    };

    fetchLocations();
    fetchPositions();
  }, []);

  useEffect(() => {
    const fetchAvailableJobs = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/available-jobs-top5`);

        // Sort jobs by postedAt descending (newest first)
        const sortedJobs = response.data.slice().sort((a, b) => {
          const dateA = a.postedAt ? new Date(a.postedAt) : new Date(0);
          const dateB = b.postedAt ? new Date(b.postedAt) : new Date(0);
          return dateB - dateA;
        });

        setJobs(sortedJobs);
        setAnimateKey((prev) => prev + 1);
      } catch (err) {
        console.error('Error fetching available jobs:', err.message);
        toast.error('Trenutno nije moguće učitati oglase. Pokušajte kasnije.');
        setJobs([]);
      }
    };

    fetchAvailableJobs();
  }, []);

  const jobDescriptionStyle = useMemo(
    () => ({
      display: '-webkit-box',
      WebkitLineClamp: 5,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      height: '110px',
    }),
    []
  );

  return (
    <>
      <Helmet>
      <title>Pronađite Posao u Hrvatskoj i Crnoj Gori | Sezonski Poslovi Star</title>
      <meta
        name="description"
        content="Star Jobs vam pomaže da pronađete stalni ili sezonski posao u Hrvatskoj i Crnoj Gori. Pretražite oglase, prijavite se online i započnite svoju karijeru!"
      />
      <meta name="keywords" content="poslovi, sezonski poslovi, stalni posao, Hrvatska, Crna Gora, zapošljavanje, karijera, oglasi za posao" />
      <meta property="og:title" content="Pronađite Posao u Hrvatskoj i Crnoj Gori | Sezonski Poslovi Star" />
      <meta
        property="og:description"
        content="Sezonski Poslovi Star — najnoviji oglasi za sezonske i stalne poslove u Hrvatskoj i Crnoj Gori. Pronađite posao brzo i lako!"
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.mycompany.com/" />
      <meta property="og:image" content="/images/seo-banner.jpg" />
    </Helmet>


      <Header />
      <div className="home-page-bg-wrapper">

        {/* --- SEARCH (simple + robust) --- */}
        <form className="home-search" onSubmit={handleNewSearch}>
          <div className="search-grid">

<div className="sf">
  <select
    value={jobTypeSearch}
    onChange={(e) => setJobTypeSearch(e.target.value)}
    className="job-type-select"
    aria-label="Pretražite po tipu posla"
  >
    <option value="">Odaberite tip posla...</option>
    <option value="Stalni">Stalni</option>
    <option value="Sezonski">Sezonski</option>
  </select>
</div>


            <div className="sf" ref={locationDropdownRef}>
              <input
                type="text"
                placeholder="Pretražite na osnovu lokacije..."
                ref={locationInputRef}
                value={locationSearch}
                // onChange={handleLocationInputChange}
                onChange={handleLocationInputChange}
                //onFocus={() => setShowLocationSuggestions(true)}
                onFocus={() => {
                setShowLocationSuggestions(true);
                setShowJobTypeSuggestions(false);
                setShowPositionSuggestions(false);
                setLocationSearch((prev) => addTrailingWhileEditing(prev)); // <-- add this
              }}

                onBlur={commitLocations}                           // ← ADD
  onKeyDown={(e) => guardEnter(e, locationSearch, locationMap)} 

                aria-label="Pretražite na osnovu lokacije"
              />
                {showLocationSuggestions && (
                  <ul className="sugs">
                    {(() => {
                      const token = getLastToken(locationSearch);
                      const catalog = ['CRO', 'MNE', ...locationSuggestions.map(i => i.job_location)];

                      const filtered = catalog.filter(label =>
                        !token || label.toLowerCase().includes(token.toLowerCase())
                      );

                      const selectedTokens = locationSearch.split(',').map(t => t.trim()).filter(Boolean);

                      return filtered.map((label) => {
                        const isSelected = selectedTokens.includes(label);
                        const isCode = label === 'CRO' || label === 'MNE';
                        return (
                          <li key={label} onMouseDown={() => handleLocationSuggestionClick(label)}>
                            {isCode ? <strong>{label}</strong> : label}
                            {isSelected && <span className="tick">✓</span>}
                          </li>
                        );
                      });
                    })()}
                  </ul>
                )}


            </div>

            <div className="sf" ref={positionDropdownRef}>
              <input
                type="text"
                placeholder="Pretražite po željenoj poziciji..."
                ref={positionInputRef}
                value={positionSearch}
                // onChange={(e) => setPositionSearch(e.target.value)}
                onChange={handlePositionInputChange}
                //onFocus={() => setShowPositionSuggestions(true)}
                onFocus={() => {
                setShowPositionSuggestions(true);
                setShowLocationSuggestions(false);
                setShowJobTypeSuggestions(false);
                setPositionSearch((prev) => addTrailingWhileEditing(prev)); // <-- add this
              }}
                onBlur={commitPositions}                             // ← ADD
  onKeyDown={(e) => guardEnter(e, positionSearch, positionMap)}  // ← ADD

                aria-label="Pretražite po željenoj poziciji"
              />
                {showPositionSuggestions && (
                  <ul className="sugs">
                    {(() => {
                      const token = getLastToken(positionSearch);
                      const names = positionSuggestions.map(i => i.job_name);

                      const filtered = names.filter(name =>
                        !token || name.toLowerCase().includes(token.toLowerCase())
                      );

                      const selectedTokens = positionSearch.split(',').map(t => t.trim()).filter(Boolean);

                      return filtered.map((name) => {
                        const isSelected = selectedTokens.includes(name);
                        return (
                          <li key={name} onMouseDown={() => handlePositionSuggestionClick(name)}>
                            {name} {isSelected && <span className="tick">✓</span>}
                          </li>
                        );
                      });
                    })()}
                  </ul>
                )}


            </div>

            <button className="search-btn" type="submit">PRETRAŽI POSLOVE</button>
          </div>
        </form>

        {/* JOBS */}
        <div className="home-page-container">
          <div className="search-section">
            <ul key={animateKey} className="fade-in">
              {jobs.map((job) => (
                <JobCard key={job.id} job={job} jobDescriptionStyle={jobDescriptionStyle} />
              ))}
            </ul>
          </div>
        </div>
      </div>

{/* HOW WE WORK */}
<section className="how-section">
  <h2 className="how-title">Kako funkcionišemo?</h2>

  <ol className="how-steps">
    <li className="how-card">
      <span className="how-badge">1</span>
      <div className="how-icon">
        <FaCheckSquare />
      </div>
      <h3 className="how-card-title">Provjerite otvorene pozicije</h3>
      <p className="how-card-text">Pretražite oglase po lokaciji i poziciji.</p>
    </li>

    <li className="how-card">
      <span className="how-badge">2</span>
      <div className="how-icon">
        <HiOutlineDocumentSearch />
      </div>
      <h3 className="how-card-title">Pronađite oglas koji odgovara</h3>
      <p className="how-card-text">Uporedite uslove, smještaj i obroke.</p>
    </li>

    <li className="how-card">
      <span className="how-badge">3</span>
      <div className="how-icon">
        <FaWpforms />
      </div>
      <h3 className="how-card-title">Aplicirajte online</h3>
      <p className="how-card-text">Popunite brzu prijavu ili pošaljite CV.</p>
    </li>

    <li className="how-card">
      <span className="how-badge">4</span>
      <div className="how-icon">
        <BsChatDots />
      </div>
      <h3 className="how-card-title">Kontakt i dogovor</h3>
      <p className="how-card-text">Naš tim Vas kontaktira i vodi dalje.</p>
    </li>
  </ol>

  <div className="how-cta">
    <Link className="how-btn" to="/jobs-page">Pogledaj oglase</Link>
  </div>
</section>

    <PartnersSection />




    <Footer />
    
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
    />
    </>
  );
}


export default HomePage;
